/** @jsxImportSource @emotion/react */

import { css } from "@emotion/react";
import MainLayout from "layout/MainLayout";
import { useEffect, useState } from "react";
import { homeReadDocument } from "service/homeService";

export default function Home() {
    const [youtubePlaceList, setYoutubePlaceList] = useState(new Array())
    const [viewRestaurantPlaceList, setViewRestaurantPlaceList] = useState(new Array())

    useEffect(() => {
        getFirebaseDocument()
    }, [])

    const getFirebaseDocument = async () => {
        // 가져오기
        const querySnapshot = await homeReadDocument("home_list")

        // 변환
        let tmpMarkerList = new Array()
        querySnapshot.forEach((doc) => {
            tmpMarkerList.push(doc.data())
        });

        const newList1 = tmpMarkerList.filter((item) => (
            item.category.includes("유튜브")
        ))

        // @ts-ignore
        setYoutubePlaceList(newList1)

        const newList2 = tmpMarkerList.filter((item) => (
            item.category.includes("맛집")
        ))

        // @ts-ignore
        setViewRestaurantPlaceList(newList2) 
    }

    const settingImage = (info: any) => {
        let tmpImageSrc = require("../assets/images/seong_si_kyung.png")
        return tmpImageSrc
    }

    const settingImage2 = (info: any) => {
        let tmpImageSrc = require("../assets/images/pung_ja.png")
        return tmpImageSrc
    }

    return (
        <MainLayout>
            <div css={MainWrapperStyle} style={{height: window.innerHeight - 120 + 'px'}}>
                <div css={IntroductionWrapperStyle}>
                    <div css={IntroductionImageStyle}></div>
                </div>

                <div css={PlaceWrapperStyle}>
                    <div css={PlaceTitleWrapperStyle}>이달의 유튜브</div>
                    <div css={PlaceListWrapperStyle}>
                        {youtubePlaceList?.map((item: any) => (
                            <div>
                                <img src={item?.image_url ? item?.image_url : settingImage(item)} alt="test" css={PlaceListImageStyle} loading="lazy"></img>
                                <div css={CardInfoWrapperStyle}>
                                    <div css={CategoryInfoStyle}>
                                        {item.category}
                                    </div>
                                    <div css={TitleInfoStyle}>
                                        {item.title}
                                    </div>
                                    <div css={AddressInfoStyle}>
                                        {`(${item.addr1})`}
                                    </div>
                                    <div css={PhoneInfoStyle}>
                                        {item.phone}
                                    </div>
                                    <div css={MenuInfoStyle}>
                                        {item.menu}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                <div css={PlaceWrapperStyle}>
                    <div css={PlaceTitleWrapperStyle}>이달의 맛집</div>
                    <div css={PlaceListWrapperStyle}>
                        {viewRestaurantPlaceList?.map((item: any) => (
                            <div>
                                <img src={item?.image_url ? item?.image_url : settingImage2(item)} alt="test" css={PlaceListImageStyle} loading="lazy"></img>
                                <div css={CardInfoWrapperStyle}>
                                    <div css={CategoryInfoStyle}>
                                        {item.category}
                                    </div>
                                    <div css={TitleInfoStyle}>
                                        {item.title}
                                    </div>
                                    <div css={AddressInfoStyle}>
                                        {`(${item.addr1})`}
                                    </div>
                                    <div css={PhoneInfoStyle}>
                                        {item.phone}
                                    </div>
                                    <div css={MenuInfoStyle}>
                                        {item.menu}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

            </div>
        </MainLayout>
    )
}

const MainWrapperStyle = css`
    padding: 14px;

    width: 100%;
    height: 100%;

    overflow-x: hidden;
    overflow-y: auto;

    -ms-overflow-style: none; /* for Internet Explorer, Edge */
    scrollbar-width: none; /* for Firefox */

    &::-webkit-scrollbar {
        display: none; /* for Chrome, Safari, and Opera */
    }
`

const IntroductionWrapperStyle = css`
    display: flex;

    width: 100%;
    height: 270px;

    /* background: yellow; */
`

const IntroductionInfoStyle = css`
    font-size: 30px;

    width: calc((100% / 2));

    text-align: center;

    /* background: yellow; */
`

const IntroductionImageStyle = css`
    width: 100%;

    background: var(--primary-color);
`

const PlaceWrapperStyle = css`
    width: 100%;

    margin-top: 40px;

    /* background: yellow; */
`

const PlaceTitleWrapperStyle = css`
    font-size: 16px;
    font-weight: 600;

    /* background: yellow; */
`

const PlaceListWrapperStyle = css`
    display: flex;

    width: 100%;
    height: 100%;

    margin-top: 5px;

    gap: 10px;

    overflow-x: auto;

    -ms-overflow-style: none; /* for Internet Explorer, Edge */
    scrollbar-width: none; /* for Firefox */

    &::-webkit-scrollbar {
        display: none; /* for Chrome, Safari, and Opera */
    }
`

const PlaceListImageStyle = css`
    width: 100%;
    height: 150px;

    background: gray;

    /* border-radius: 30px; */

    text-align: center;
`

const CardInfoWrapperStyle = css`
    width: 150px;
    background: #fff;
    padding: 17.5px;
    overflow: hidden;
`

const CategoryInfoStyle = css`
    font-size: 13.1px;
    color: #333;
`

const TitleInfoStyle = css`
    font-size: 17.5px;
    color: #111;
    font-weight: 700;
    line-height: 1.3;
    word-break: keep-all;
    margin-top: 4.4px;
`

const AddressInfoStyle = css`
    font-size: 15.4px;
    color: #111;
    font-weight: 700;
`

const PhoneInfoStyle = css`
    font-size: 15.4px;
    color: #289997;
    margin-top: 4.4px;
`

const MenuInfoStyle = css`
    font-size: 12.3px;
    color: #111;
    font-weight: 300;
    line-height: 1.3;
    word-break: keep-all;
    margin-top: 4.4px;
`

